module.exports = __webpack_public_path__ + "static/media/4.96c2eb3b.JPG";